import React, {useContext, useRef, useState} from 'react';

import UserInfos from "./components/UserInfos";
import SettingsMenuContent from "./components/SettingsMenuContent";
import SidebarFloatMenu from "../../../SidebarFloatMenu";
import BottomDrawer from "../../../BottomDrawer";

import {SidebarContext} from "../../../../../../SidebarContext";

function UserProfile(props) {
    const [anchorEl, setAnchorEl] = useState(null);

    const anchorRef = useRef(null);

    const {isMobile} = useContext(SidebarContext);

    function handleClick(event){
        setAnchorEl(anchorRef.current);
    }

    return (
        <div>
            <div ref={anchorRef} onClick={handleClick}>
                <UserInfos />
            </div>
            {isMobile ? (
                <BottomDrawer
                    open={!!anchorEl}
                    onClose={() => setAnchorEl(null)}
                    title='Mon compte'
                >
                    <SettingsMenuContent />
                </BottomDrawer>
            ) : (
                <SidebarFloatMenu
                    anchorEl={anchorEl}
                    open={!!anchorEl}
                    onClose={() => setAnchorEl(null)}
                    customMarginLeft={'0%'}
                    anchorOrigin = {{vertical: 'top', horizontal: 'center'}}
                    transformOrigin = {{vertical: 'bottom', horizontal: 'left'}}
                >
                    <SettingsMenuContent />
                </SidebarFloatMenu>
            )}
        </div>
    );
}

export default UserProfile;
